<script>
    import { Modal } from '../static/bootstrap.js';

    import galleryGroup from '../static/galleryPageGrouping';

    import Image from '../elements/image.svelte';

    let sortedGallery = [];
    /* Object.keys(galleryGroup).reverse().forEach((group, index) => {
        galleryGroup[group].forEach(image => {
            if (sortedGallery.length < 6) {
                sortedGallery.push(image);
            }
        });
    }); */

    Object.keys(galleryGroup).reverse().forEach((group, index) => {
        galleryGroup[group].every(image => {
            if (sortedGallery.length < 6) {
                sortedGallery.push(image);
                return true;
            }

            return false;
        })
    });
</script>

<div class="illus-component-wrapper" id="illustrations">
    <div class="page-image"></div>
    <div class="page-content">
        
        <div class="container">
            <h1 class="font-VarelaRound">illustrations</h1>
        </div>

        <div class="container">
            <div class="row">
                {#each sortedGallery as image}
                <div class="col-md-6 my-4">
                    <div style="width:70%;" class="mx-auto">
                        <Image
                            src="build/assets/img/gallery_details/{image}"
                            eleclass="img-fluid img-thumbnail bg-transparent"
                            on:click={() => new Modal(document.getElementById(image.replaceAll(' ', ''))).toggle()} />
                    </div>

                    <div class="modal fade" id={image.replaceAll(' ', '')}>
                        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <Image src="build/assets/img/gallery_details/{image}" style="max-width:100%;" />
                        </div>
                    </div>
                </div>
	            {/each}
            </div>
        </div>

        <p class="text-center py-5">
            <a href="#/illustrations" class="btn btn-primary btn-lg mx-auto">More</a>
        </p>

    </div>
</div>

<style lang="scss">
	@import "src/scss/illustrations";
</style>